export default __webpack_public_path__ + "static/jean.repairClothes-08e936b8f3bc2b9ffea5e97e64f858fb.jpg";